import { render, staticRenderFns } from "./BoxSpecFields.vue?vue&type=template&id=8170c4e2&scoped=true&"
import script from "./BoxSpecFields.vue?vue&type=script&lang=js&"
export * from "./BoxSpecFields.vue?vue&type=script&lang=js&"
import style0 from "./BoxSpecFields.vue?vue&type=style&index=0&id=8170c4e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8170c4e2",
  null
  
)

export default component.exports